import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ml2" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "nowrap" }
const _hoisted_4 = {
  key: 1,
  class: "admin-panel-icebreaker-custom-questions__edit ml2"
}
const _hoisted_5 = { class: "edit__header flex justify-between items-center mb2" }
const _hoisted_6 = { class: "edit__header-title" }
const _hoisted_7 = {
  key: 0,
  class: "edit__wrapper p2"
}
const _hoisted_8 = { class: "input-wrapper" }
const _hoisted_9 = { for: "text-en" }
const _hoisted_10 = { class: "input-wrapper" }
const _hoisted_11 = { for: "text-pl" }
const _hoisted_12 = { class: "p-field flex flex-column mt1" }
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = { class: "mr1" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "pi pi-question-circle mb1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_BaseTooltipWrapper = _resolveComponent("BaseTooltipWrapper")!
  const _component_AdminPanelHeader = _resolveComponent("AdminPanelHeader")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_DropdownSelect = _resolveComponent("DropdownSelect")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_AdminPanelHeader, {
      title: _ctx.$t('gamesCommon.customQuestions')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Button, { onClick: _ctx.addNew }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('gamesCommon.addNewCustomQuestion')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_BaseTooltipWrapper, {
            title: _ctx.$t('gamesCommon.startNewGameWithSelectedTooltip')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Button, { onClick: _ctx.startNewGameWithSelectedQuestions }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('gamesCommon.startNewGameWithSelected')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode("div", _hoisted_2, [
      (_ctx.customQuestions.length)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            class: "admin-panel-icebreaker-custom-questions__all",
            value: _ctx.customQuestions,
            responsiveLayout: "scroll",
            selection: _ctx.selectedQuestions,
            "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedQuestions = $event)),
            onRowClick: _ctx.editQuestionFromRow
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                selectionMode: "multiple",
                style: {"width":"3rem"},
                exportable: false
              }),
              _createVNode(_component_Column, {
                field: "textEn",
                header: _ctx.$t('gamesCommon.questionEn')
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "textPl",
                header: _ctx.$t('gamesCommon.questionPl')
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "type",
                header: _ctx.$t('gamesCommon.type')
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("span", _hoisted_3, _toDisplayString(slotProps.data.type === _ctx.FUN_ICE_BREAKER_QUESTION_TYPES.SINGLE
                ? _ctx.$t(`funIceBreaker.customQuestions.types.${_ctx.FUN_ICE_BREAKER_QUESTION_TYPES.SINGLE}`)
                : _ctx.$t(
                    `funIceBreaker.customQuestions.types.${_ctx.FUN_ICE_BREAKER_QUESTION_TYPES.TRUTHLIE}`
                  )), 1)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "actions",
                header: _ctx.$t('gamesCommon.actions')
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("i", {
                    class: "pi pi-trash",
                    onClick: ($event: any) => (_ctx.deleteCustomQuestion(slotProps.data.id))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          }, 8, ["value", "selection", "onRowClick"]))
        : _createCommentVNode("", true),
      (_ctx.customQuestions.length)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('gamesCommon.editor')), 1),
              _createVNode(_component_Button, {
                class: "ml1",
                onClick: _ctx.handleSaveCustomQuestion
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('gamesCommon.saveQuestion')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            (_ctx.questionEdited)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('gamesCommon.questionTextEn')), 1),
                    _createVNode(_component_Textarea, {
                      id: "text-en",
                      rows: "5",
                      modelValue: _ctx.questionEdited.textEn,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.questionEdited.textEn = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('gamesCommon.questionTextPl')), 1),
                    _createVNode(_component_Textarea, {
                      id: "text-pl",
                      rows: "5",
                      modelValue: _ctx.questionEdited.textPl,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.questionEdited.textPl = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode("span", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('funIceBreaker.customQuestions.type')), 1),
                      _createVNode(_component_BaseTooltipWrapper, {
                        tooltip: _ctx.$t('funIceBreaker.customQuestions.typeTooltip')
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["tooltip"])
                    ]),
                    _createVNode(_component_DropdownSelect, {
                      modelValue: _ctx.questionEdited.type,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.questionEdited.type = $event)),
                      options: _ctx.typeOptions,
                      "option-label": "label",
                      "option-value": "value"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}